import React from 'react'
import {
  Dialog,
  IconClose24,
} from '@lightspeed/unified-components-helios-theme/react'

export interface UnifiedDialogProps {
  children: React.ReactNode
  onClose: () => void
}

const getAutocompletePopover = () =>
  document.querySelector<HTMLElement>('.mark-as-unfulfilled-customer-popover')

const getOutletSelectDropdownPortal = () =>
  Array.from(
    document.querySelectorAll<HTMLElement>('.wr-outlet-select-dropdown-portal')
  ).pop() ?? null

const getActiveChildModal = () =>
  Array.from(
    document.querySelectorAll<HTMLElement>('.vd-modals-container')
  ).pop() ?? null

const getActiveWorkflowPopover = () =>
  document.querySelector<HTMLElement>('.workflow-popover')

const getActiveWorkflowPopoverOverlay = () =>
  document.querySelector<HTMLElement>('.workflow-popover-overlay')

const getActiveSaleAddressModal = () =>
  document.querySelector<HTMLElement>('.sale-address-modal-wrapper')

export const UnifiedDialog: React.FC<UnifiedDialogProps> = props => {
  const handleClose = () => {
    if (getActiveSaleAddressModal()) return
    props.onClose()
  }

  return (
    <div className="uc-base">
      <Dialog
        opened
        portalDisabled
        modal={false}
        trapFocus={false}
        preventScroll={false}
        closeOnInteractOutside
        persistentElements={[
          getAutocompletePopover,
          getOutletSelectDropdownPortal,
          getActiveChildModal,
          getActiveWorkflowPopover,
          getActiveWorkflowPopoverOverlay,
          getActiveSaleAddressModal,
        ]}
        onClose={handleClose}
        size="medium"
        closeControlSlot={<IconClose24 />}
        customClasses={{ closeControl: 'right-8 top-4' }}
      >
        {props.children}
      </Dialog>
    </div>
  )
}

UnifiedDialog.displayName = 'UnifiedDialog'
